import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1164.23,160.333 L1468.24,160.333 L1468.24,498.153 L840.282,1126.11 C808.659,1157.73 790.588,1200.65 790.588,1245.82 L790.588,1641.12 L1185.88,1641.12 C1231.06,1641.12 1273.98,1623.05 1305.6,1591.42 L1468.24,1428.79 L1468.24,1867 L0,1867 L0,160.333 L329.104,160.333 C351.069,98.19 410.335,53.667 480,53.667 L1013.33,53.667 C1083,53.667 1142.26,98.19 1164.23,160.333 Z M426.667,213.667 C426.667,184.211 450.545,160.333 480,160.333 L1013.33,160.333 C1042.79,160.333 1066.67,184.211 1066.67,213.667 L1066.67,373.667 L426.667,373.667 L426.667,213.667 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1677.57,528.308 L1903.45,754.19 C1925.47,776.214 1925.47,811.903 1903.45,834.04 L1225.8,1511.69 C1215.18,1522.19 1200.84,1528.18 1185.82,1528.18 L903.467,1528.18 L903.467,1245.82 C903.467,1230.8 909.453,1216.46 919.956,1205.95 L1597.6,528.308 C1619.74,506.171 1655.43,506.171 1677.57,528.308 Z M1548.02,737.588 L1694.05,883.621 L1783.61,794.059 L1637.58,648.026 L1548.02,737.588 Z"
}));

var IconNotepadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconNotepadSolid, _Component);

  var _super = _createSuper(IconNotepadSolid);

  function IconNotepadSolid() {
    _classCallCheck(this, IconNotepadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconNotepadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNotepad",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNotepadSolid.displayName = "IconNotepadSolid";
  return IconNotepadSolid;
}(Component);

IconNotepadSolid.glyphName = 'notepad';
IconNotepadSolid.variant = 'Solid';
IconNotepadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNotepadSolid;
export { IconNotepadSolid };